// GENERATED by scripts/gen-version.js — do not edit by hand.
// Source of truth is package.json "version"; regenerated on prestart/prebuild.
export const APP_VERSION = "1.1.91";
